import React, { useState, useContext, useEffect } from "react";
import axios from "axios";

import MonthPickerComponent from "../Utils/MonthPickerComponent";
import xls from "../images/xls/png/Group 47.png";
// import ExcelPopup from "../Components/ExcelPopup";
import line from "../images/line.png";
import moment from "moment";
import FileIcon from "../images/file.png";
import FileIconBlur from "../images/fileblur.png";
import Card from "../Components/ListPageCard/Card";
import Layout from "../Components/Layout";
import MainMenu from "../Components/MainMenu";
import Table from "../Components/TableComponent";
import FilterTag from "../Components/Tag";
import RefineSearch from "../Components/RefineSearchComponent";
// import chatPopupIcon from "../images/chatPopupIcon.png";
// import ChatPopup from "../Components/ChatPopup";
import "../index.css";
import SavedFilterContent from "../Components/SavedFilter";
import ExportPopup, { useExportRequest } from "../Components/ExportPopup";
import { data } from "../Components/ExportPopup/ExportData";
import { exportPDF, getPEDealsApi } from "../Config/config";
import InvestmentRefineSearch from "../Components/RefineSearch/InvestmentRefineSearch";
import Constants from "../Constants";
import { useLocation } from "react-router";
import { PeFilterContext } from "../Contexts/PeFilterContext";
// import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
// import MonthRangePicker from "../Components/shared/MonthRangePicker";
import { UserContext } from "../Contexts/UserContext";
import DirectoryDownloadAccess, {
  ExportDirectoryExcel,
} from "../Components/ExportPopup/DirectoryExport";
import { Switch, Tooltip } from "antd";
import ConfirmPopup from "../Utils/ConfirmPopup";
import ExcelDownloader from "../Components/shared/ExcelDownloader";
import { TableDataContext } from "../Contexts/TableDataContext";
import ToggleDealsViewButton from "../Components/ToggleDealsView";
import { FaFilter, FaChartBar } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { RiMailDownloadLine } from "react-icons/ri";
import DownloadTrigger from "../Components/ExportPopup/DownloadTrigger";
import ChartPopup from "../Components/ChartPopup/ChartPopup";
import useChartAnalytics from "../hooks/useChartAnalytics";
import FeatureTour from "../Components/FeatureTour";

// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';
// import { notification } from "antd";

// import echo  from '../../src/Components/NotificationSettings/echo';

/**
 * The Home function is a JavaScript function that renders a page layout with a top navigation bar, a
 * main content area with a filter tag and a table, and a sidebar with refine search options.
 * @returns The Home component is being returned.
 */
function Home() {
  
  // const [showModal, setShowModal] = React.useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [showFeatureTour, setShowFeatureTour] = useState(false);
  
  const { refineSearchFilters, isMobile, setOpen, open, setIsMobile, monthPickerValue, SubFirmType, accessControl, setrefineSearchFilters } = useContext(PeFilterContext);
  const { save, setSave, showMonthPicker, groupId, dealsView, setDealsView, switchValue, setSwitchValue } = useContext(PeFilterContext);
  const { globalSearchResult, chartData, setChartData } = useContext(TableDataContext);
  const { getToken, logout, shouldShowFeatureTour, markFeatureTourAsShown } = useContext(UserContext);
  
  useEffect(()=>{
    if (window.innerWidth < 800) {
        // setOpen(true);
        setIsMobile(true);
    }
    
    // Check if feature tour should be shown globally (once across all modules)
    if (shouldShowFeatureTour()) {
      // Show tour after a short delay to ensure elements are rendered
      setTimeout(() => {
        setShowFeatureTour(true);
      }, 1000);
    }
  }, [])

  // const [showNotification, setShowNotification] = useState(false)
  /**
   * The function `savedList` toggles the value of the `save` variable.
   */
  const savedList = () => {
    setSave(!save);
  };

  const { pathname } = useLocation();
  const { isStudent, isDirectoryUser, isTrialExport } = useContext(UserContext);
  const [alertMsg, setalert] = useState({
    message: Constants.excelPopupMessage,
    show: true,
    icon: "",
  });
  
  const pathKey = pathname.split("/").slice(0, 3).join("/"); // Gets '/pe/companies'
  console.log(refineSearchFilters[pathKey], "isStudent");
  
  useEffect(()=>{
    if (window.innerWidth < 800) {
      // setOpen(true);
      setIsMobile(true);
    }    
    setrefineSearchFilters((prev) => ({
        ...prev,
        [pathKey]: {
            ...prev[pathKey],
            exitStatus:[]
        }
    }))
  },[])

  const onConfirmation = (flag) => {
    setalert({ show: false, message: "" });
  };

  // Use chart analytics hook
    const {
      showChartPopup,
      setShowChartPopup,
      currentChartData,
      setCurrentChartData,
      isChartLoading,
      setIsChartLoading,
      currentShowBy,
      fallbackChartData,
      getAvailableShowByOptions,
      handleChartIconClick,
      handleShowByChange,
      interval,
      handleIntervalChange,
      period,
      handlePeriodChange
    } = useChartAnalytics("pe", pathname);

    const { requestBodyForExport } = useExportRequest({ type:"pe_vc_investment", modules:"company", module, url:exportPDF, filterData:data, module_type:"pe" })

    console.log(requestBodyForExport, "export body")

  return (
    <>
      <Layout menu="pe">
        <div className="flex min-h-screen h-screen flex-col">
          {/* Top nav*/}
          <div className={`transition-all duration-500 ease-in-out ${showChartPopup ? 'opacity-0 -translate-y-4 h-0 overflow-hidden' : 'opacity-100 translate-y-0'}`}>
            {!showChartPopup && <Card />}
          </div>
          {/* Bottom section */}
          <div className={`transition-all duration-500 ease-in-out ${showChartPopup ? "mt-12" : ""} flex min-h-0 flex-1 overflow-hidden`}>
            {/* Narrow sidebar*/}
            {/* Main area */}
            <main className= {"min-w-0 flex-1 border-t border-gray-200 flex"}>
              {/* Primary column */}
              <section className="flex min-w-0 flex-1 flex-col lg:order-last bg-[#EDEDED]">
                {/* Your content */}
                <div className="sm-items-center  mr-0 md:mr-[5rem] flex flex-row align-middle md:flex-row justify-between items-start md:items-center gap-0 md:gap-2 px-4 md:px-0 py-1 md:py-0 flex-shrink-0 lg:items-center xl:items-center">
                  <FilterTag />
                  <ToggleDealsViewButton handleChartIconClick={handleChartIconClick} />
                </div>
                <div className="pl-3 pr-4 lg:pr-4 md:pr-5">
                  <div className="px-2  md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between">
                    <MainMenu active={1} menu="pe" subMenu="investment" />

                        <div
                          className={
                            "justify-between items-center px-2 py-2 space-x-4 " +
                            (showMonthPicker != 0 ? "md:flex" : "flex")
                          }
                        >
                          <label htmlFor="" className="text-[#666666] ">
                            <div className={showMonthPicker != 0 ? "" : "flex"}>
                              <MonthPickerComponent />
                            </div>
                          </label>
                          {/* <button
                            className="cursor-pointer lg:ml-7 ml-4 mt-2"
                            onClick={() => setOpen(!open)}
                            aria-label="filter-button"
                          >
                            <FaFilter color="#bc8b20" size={21} />
                          </button> */}
                          <a>
                            <img
                              className="h-[24px] max-w-[2px] mt-1 "
                              src={line}
                            />
                          </a>
                          {isStudent == "true" || showChartPopup ? (
                            <></>
                            ) : (
                              <div
                                className={
                                  showMonthPicker != 0
                                    ? "hidden md:flex space-x-3"
                                    : "flex space-x-3"
                                }
                              >
                              <Tooltip 
                                title="Download as Excel" 
                                color="#ffffff"
                                overlayInnerStyle={{ color: '#000000', fontSize: '14px', fontWeight: '500', width: 'max-content' }}
                              >
                                <button>
                                  {isTrialExport == "false" ? (
                                    <ExcelDownloader
                                      url={exportPDF}
                                      fileName={
                                        Constants.exportNames
                                          .pe_company_investment
                                      }
                                      data={{ type: "pe_vc_investment" }}
                                      children={
                                        <DownloadTrigger />
                                      }
                                    />
                                  ) : (
                                    <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                                  )}
                                </button>
                              </Tooltip>
                              <img
                                alt=""
                                className="h-[24px] w-[2px] mt-1 "
                                src={line}
                              />
                            </div>
                          )}
                          <Tooltip 
                            title="Save Your List" 
                            color="#ffffff"
                            overlayInnerStyle={{ color: '#000000', fontSize: '14px', fontWeight: '500', width: 'max-content' }}
                          >
                            <div className="group cursor-pointer">
                              <div className="cursor-pointer" onClick={savedList}>
                                <img
                                  src={save ? FileIcon : FileIconBlur}
                                  className="max-h-[24px] mt-1 max-w-[21px]"
                                  alt=""
                                />
                              </div>
                            </div>
                          </Tooltip>
                        </div>
                  </div>
                  {save ? (
                    <SavedFilterContent
                      primaryTypeMasterId={Constants.primaryMasterIds.peId}
                      subTypeMasterId={
                        Constants.primaryMasterSubIds.pe_vc_investments_id
                      }
                      typeId={Constants.moduleIds.companiesId}
                      show={save}
                      exportPayload={requestBodyForExport}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div id="overFlow" className="overflow-y-auto h-full">
                  {!showChartPopup ? <Table
                    menu="pe"
                    sub_type_master_id={
                      Constants.subCategoryIds.pe_investments_id}
                  /> : (
                    <ChartPopup
                      isOpen={showChartPopup}
                      onClose={() => {
                        setShowChartPopup(false);
                        setIsChartLoading(false);
                        setCurrentChartData(null);
                      }}
                      data={currentChartData || fallbackChartData}
                      isLoading={isChartLoading}
                      showBy={currentShowBy}
                      availableShowByOptions={getAvailableShowByOptions()}
                      onShowByChange={handleShowByChange}
                      menuType="pe"
                      subType="PE - VC Investments"
                      interval={interval}
                      onIntervalChange={handleIntervalChange}
                      period={period}
                      onPeriodChange={handlePeriodChange}
                      redirectPath={pathname}
                    />
                  )}
                </div>
              </section>
              {/* Secondary column (hidden on smaller screens) */}
              <aside className={`order-first block flex-shrink-0 ${isMobile ? "pt-14" : ""}`}>
                <div className="relative flex flex-col border-r border-gray-200 bg-[#FAF5EA]">
                  {/* Your content */}
                  <RefineSearch>
                    <InvestmentRefineSearch customPathname={pathname} generalPathname={"/pe/companies"} />
                  </RefineSearch>
                </div>
              </aside>
            </main>
          </div>
        </div>
        {showPopup && (
          <ExportPopup
            modules="company"
            fileName={
              Constants.exportNames
                .pe_company_investment
            }
            url={exportPDF}
            module_type="pe"
            onClose={() => setShowPopup(false)}
            exportOptions={data}
            isExport={isTrialExport}
            type="pe_vc_investment"
          />
        )}
        
        {/* Feature Tour */}
        {showFeatureTour && (
          <FeatureTour onClose={() => {
            markFeatureTourAsShown();
            setShowFeatureTour(false);
          }} />
        )}
      </Layout>
    </>
  );
}

export default Home;



      
      {/* Chart Popup */}
      // {showChartPopup && (
      //   <ChartPopup
      //     isOpen={showChartPopup}
      //     onClose={() => {
      //       setShowChartPopup(false);
      //       setIsChartLoading(false);
      //       setCurrentChartData(null);
      //     }}
      //     data={currentChartData || displayChartData}
      //     isLoading={isChartLoading}
      //     showBy={currentShowBy}
      //     availableShowByOptions={getAvailableShowByOptions()}
      //     menuType="pe"
      //     subType="PE - VC Investments"
      //     onShowByChange={async (newShowBy) => {
      //       setCurrentShowBy(newShowBy);
      //       setIsChartLoading(true);
            
      //       // Re-fetch data with new show_by value
      //       try {
      //         const currentShowByValue = newShowBy;
              
      //         // Define the menu type for PE investments (this is PeHome component)
      //         const menu = "pe";
      //         const category = "investments"; // For PE investments
              
      //         // Helper function to get global search IDs (simplified version)
      //         const getGlobalSearchIds = () => {
      //           if (!isFromGlobalSearch()) return [];
      //           // Return relevant deal IDs from global search context
      //           return globalSearchResult?.pe_investment || [];
      //         };

      //         // Extract PE and VC IDs from SubFirmType
      //         const peIds = SubFirmType
      //           ?.filter(firm => firm.name?.includes('(PE)'))
      //           ?.map(firm => firm.id) || [];

      //         const vcIds = SubFirmType
      //           ?.filter(firm => firm.name?.includes('(VC)'))
      //           ?.map(firm => firm.id) || [];

      //         // Extract IDs from refineSearchFilters
      //         const refineIds = refineSearchFilters[pathKey]?.firm_Sub_type?.map(firm => firm.id) || [];

      //         // Filter PE and VC IDs from refineIds
      //         const filteredPeIds = refineIds.filter(id => peIds.includes(id));
      //         const filteredVcIds = refineIds.filter(id => vcIds.includes(id));

      //         const dealIds = getGlobalSearchIds();

      //         const response = await axios(getPEDealsApi, {
      //           method: "POST",
      //           data: {
      //             category: category,
      //             type: "pe_vc_investment",
      //             from: isFromGlobalSearch() ? "gs" : "",
      //             date_range: {
      //               from_date: moment(monthPickerValue?.[0] || moment().startOf("month").subtract(12, "months")).format("YYYY-MM-DD"),
      //               to_date: moment(monthPickerValue?.[1] || moment().endOf("month")).format("YYYY-MM-DD"),
      //             },
      //             tab_category: "company",
      //             industry: refineSearchFilters[pathKey]?.industry?.length > 0 
      //               ? refineSearchFilters[pathKey]?.industry?.map((value) => value.id) 
      //               : [],
      //             sector: refineSearchFilters[pathKey]?.sector?.map(
      //               (value) => value.name
      //             ) || [],
      //             deals_operator: category === "incubation" ? 'or' : category === "angel" ? refineSearchFilters[pathname]?.deals_operator : refineSearchFilters[pathKey]?.deals_operator,
      //             deal_ids: dealIds,
      //             company_ids: isFromGlobalSearch() ? []
      //               : refineSearchFilters[pathKey]?.target_company?.map(company => company.id) || refineSearchFilters[pathname]?.companyIds?.at(0)?.value,
      //             ladvisor_ids: category === "angel" || category === "incubation" ? [] : refineSearchFilters[pathKey]?.ladvisors?.map(acq => acq.id) || [],
      //             tadvisor_ids: category === "angel" || category === "incubation" ? [] : refineSearchFilters[pathKey]?.tadvisors?.map(acq => acq.id) || [],
      //             investor_ids: category === "angel" || category === "incubation" ? refineSearchFilters[pathname]?.investor_id?.map(acq => acq.id) || [] : refineSearchFilters[pathKey]?.investor_id?.map(acq => acq.id) || [],
      //             stage: refineSearchFilters[pathname]?.stage?.length > 0 ? refineSearchFilters[pathname]?.stage?.map(
      //               (value) => value.id
      //             ) : accessControl?.pe_stage?.id,
      //             round: refineSearchFilters[pathname]?.round?.map(
      //               (value) => value.name
      //             ) || [],
      //             investor_id: refineSearchFilters[pathname]?.companyIds?.at(0)?.investorId,
      //             valuation: refineSearchFilters[pathname]?.valuations?.map((valuation) => valuation.value),
      //             investor_headquaters: refineSearchFilters[pathKey]?.investorHeadquarters?.map((inv) => inv.id),
      //             investor_headquaters_city: refineSearchFilters[pathKey]?.investor_headquaters_city?.map((inv) => inv.name),
      //             deal_type: refineSearchFilters[pathname]?.dealType?.map(
      //               (type) => type.id
      //             ),
      //             company_type: refineSearchFilters[pathname]?.companyType?.map((type) => type.id),
      //             year_founded: refineSearchFilters[pathKey]?.yearFounded?.at(0) && {
      //               from: refineSearchFilters[pathKey]?.yearFounded[0]?.name,
      //               to: refineSearchFilters[pathKey]?.yearFounded[1]?.name,
      //             },
      //             syndication: refineSearchFilters[pathname]?.syndication?.at(0)?.value
      //               ? [refineSearchFilters[pathname]?.syndication?.at(0)?.value]
      //               : [],
      //             deals_involving: refineSearchFilters[pathname]?.dealsInvolving?.map((deal) => deal.value),
      //             country: refineSearchFilters[pathKey]?.countries?.length > 0 ? refineSearchFilters[pathKey]?.countries?.map(
      //               (country) => country.id
      //             ) : accessControl?.pe_countries?.id,
      //             investor_type: refineSearchFilters[pathKey]?.investorType?.map((inv) => inv.id),
      //             investor_sale: refineSearchFilters[pathname]?.investorSaleInipo?.map((inv) => inv.id),
      //             region: refineSearchFilters[pathKey]?.region?.length > 0 ? refineSearchFilters[pathKey]?.region?.map(
      //               (region) => region.id
      //             ) : accessControl?.pe_regions?.id,
      //             state: refineSearchFilters[pathKey]?.state?.length > 0 ? refineSearchFilters[pathKey]?.state?.map(
      //               (state) => state.id
      //             ) : accessControl?.pe_states?.id,
      //             city: refineSearchFilters[pathKey]?.city?.length > 0 ? refineSearchFilters[pathKey]?.city?.map(
      //               (city) => city.id
      //             ) : accessControl?.pe_cities?.id,
      //             deal_range: refineSearchFilters?.[pathname]?.hasOwnProperty("dealRange") &&
      //               refineSearchFilters[pathname]?.dealRange?.length >= 2
      //                 ? {
      //                     from: refineSearchFilters[pathname].dealRange[0].name,
      //                     to: refineSearchFilters[pathname].dealRange[1].name,
      //                   }
      //                 : {
      //                     from: accessControl?.pe_deal_range?.from,
      //                     to: accessControl?.pe_deal_range?.to,
      //                   },
      //             exit_status: category === "exits" || category === "ipos" ? refineSearchFilters[pathKey]?.exitStatus?.map((status) => status.id) : refineSearchFilters[pathname]?.exitStatus?.map((status) => status.id),
      //             exit_type: refineSearchFilters[pathname]?.exitType?.map(
      //               (type) => type.id
      //             ),
      //             exited: refineSearchFilters[pathname]?.exited?.map(
      //               (exit) => exit.id
      //             ),
      //             vc_fund: refineSearchFilters[pathname]?.vcFunded?.map(
      //               (vc) => vc.id
      //             ),
      //             incubation_status: refineSearchFilters[pathname]?.incubationStatus?.map((vc) => vc.id),
      //             defunct: refineSearchFilters[pathname]?.excludeDefunctCos?.at(0)?.value ? 1 : 0,
      //             firm_type: category === "incubation"
      //               ? refineSearchFilters[pathname]?.firmType?.map((firm) => firm.id)
      //               : {
      //                   firm_type: category === "angel"
      //                     ? refineSearchFilters[pathname]?.firmType?.map((firm) => firm.id)
      //                     : refineSearchFilters[pathKey]?.firmType?.map((firm) => firm.id),
      //                   pe_firm_sub_type: filteredPeIds.length === peIds.length ? [] : filteredPeIds,
      //                   vc_firm_sub_type: filteredVcIds.length === vcIds.length ? [] : filteredVcIds,
      //                 },
      //             return_multiple: refineSearchFilters[pathname]?.returnMultiple?.at(0) && {
      //               from: refineSearchFilters[pathname]?.returnMultiple?.at(0)?.name,
      //               to: refineSearchFilters[pathname]?.returnMultiple?.at(1)?.name,
      //             },
      //             // Chart specific parameters - Use the selected show_by value
      //             ...(currentShowByValue && { show_by: currentShowByValue }),
      //             isChart: true,
      //             view_by: 'both',
      //             tag: (refineSearchFilters[pathKey]?.tags?.length ?? 0) != 0
      //               ? {
      //                   operator: refineSearchFilters[pathKey]?.operator,
      //                   data: refineSearchFilters[pathKey]?.tags?.map(
      //                     (tag) => tag.name
      //                   ),
      //                 }
      //               : accessControl?.pe_tags.id?.length > 0 ? { 
      //                   operator: 1,
      //                   data: accessControl?.pe_tags?.name
      //                 } : null,
      //             group: {
      //               group_id: groupId?.myList?.map((id) => id.group_id)?.toString() ?? null,
      //               sub_type_master_id: groupId?.myList?.length > 0 ? Constants.subCategoryIds.pe_investments_id : null,
      //             },
      //           },
      //           headers: {
      //             "Content-Type": "application/json",
      //             Authorization: getToken(),
      //           },
      //         });

      //         if (response?.data?.success === true && response?.data?.message === "Chart data generated successfully") {
      //           const chartResponseData = response?.data;
      //           setChartData(chartResponseData);
      //           setCurrentChartData(chartResponseData);
      //           setIsChartLoading(false);
      //           console.log('Chart data updated with new show_by:', newShowBy, chartResponseData);
      //         } else if (response?.data?.message === "Success") {
      //           const freshChartData = response?.data;
      //           setChartData(freshChartData);
      //           setCurrentChartData(freshChartData);
      //           setIsChartLoading(false);
      //           console.log('Chart data updated (legacy format) with new show_by:', newShowBy, freshChartData);
      //         }
      //       } catch (error) {
      //         console.error('Error updating chart data:', error);
      //         setIsChartLoading(false);
      //       }
      //     }}
      //   />
      // )}
